import React from 'react';
import LeadsManage from './ListViewLeadsManagePage';

const Test = (props) => {
  return (<LeadsManage isTest tab="company" {...props} />);
};

export default Test;
